export interface IUpdate {
  id: string;
  type: string;
  checked: boolean;
  value: string;
}

const API_FILTER_MAP: PlainObject = {
  "room-type": "roomTypes",
  "room-size": "roomSizes",
  "room-rent": "rents",
  "room-option": "features",
};
class Filter {
  private args: PlainObject<{ [type: string]: Set<string> }>;
  private showListElement: HTMLUListElement | null;
  private sort: { [id: string]: string };
  private DEFAULT_SORT =
    document.querySelector<HTMLSelectElement>("#sortPLP")?.value ?? "0";

  constructor() {
    this.args = {};
    // only one list show globally
    this.showListElement = null;
    this.sort = {};
  }

  updateArg({ id, type, checked, value }: IUpdate) {
    const parm = this.args[id] || {};
    parm[type] = parm[type] || new Set();
    if (checked) {
      parm[type].add(value);
    } else {
      parm[type].delete(value);
    }
    this.args[id] = parm;
  }

  updateSort({ id, value }: { id: string; value: string }) {
    this.sort[id] = value;
  }

  getSort(id: string) {
    return this.sort[id] || this.DEFAULT_SORT;
  }

  updateShowListElement(target: HTMLUListElement | null) {
    this.showListElement = target;
  }

  getShowListElement() {
    return this.showListElement;
  }

  getArgs(id: string): { [type: string]: Set<string> };
  getArgs(id: string, type: string): Set<string>;
  getArgs(id: string, type?: string) {
    const arg = this.args[id] || {};
    return type ? arg[type] || new Set() : arg;
  }

  getApiFilterAndSort(id?: string) {
    // if id === undefined, will get id from first filter container.
    id =
      id ??
      document.querySelector<HTMLElement>(".container-filter")?.dataset
        ?.eventId;
    if (!id) return {};

    const filters: PlainObject = {};
    Object.entries(this.getArgs(id)).forEach(([type, selects]) => {
      const key = API_FILTER_MAP[type] as string;
      filters[key] = Array.from(selects).map((item) =>
        isNaN(Number(item)) ? item : Number(item)
      );
    });
    const sortBy = Number(this.getSort(id));

    return {
      filters,
      sortBy,
    };
  }
}

const filterState = new Filter();
export default filterState;
